<template>
  <select :value="data" class="form-control" @change="updateSelected">
    <option value="" disabled>-- Selecciona una opción --</option>
    <option :value="true">Sí</option>
    <option :value="false">No</option>
  </select>
</template>

<script>
export default {
  props: {
    data: Boolean,
  },
  setup(props, context) {
    function updateSelected(event) {
      const newValue = event.target.value;

      if (newValue === 'true') {
        context.emit('update:data', true);
      } else {
        context.emit('update:data', newValue === 'true');
      }
    }
    return {
      updateSelected,
    };
  },
};
</script>
